module.exports = __webpack_public_path__ + "static/images/money-icon.cf88a71.png";